<div class="range-container">
  <input type="range"
         [min]="0"
         [max]="maxIndex"
         [(ngModel)]="startIndex"
         (change)="onSliderChange()" />

  <input type="range"
         [min]="0"
         [max]="maxIndex"
         [(ngModel)]="endIndex"
         (change)="onSliderChange()" />

  <div class="label-container">
    <span>{{ getFormattedStart() }}</span>
    <span>{{ getFormattedEnd() }}</span>
  </div>
</div>
